'use client';

import { useEffect } from 'react';
import { useGetAllFeatureFlagStates } from '@frameio/feature-flags';
import { useIsMountableStorageEnabled } from '../../plans/hooks/useIsMountableStorageEnabled';
import { TOOLTIP_FEATURE_FLAGS } from '../constants/tooltipFeatures';
import { tooltipStore } from '../stores/tooltipStore';

/**
 * Syncs feature-flag-driven tooltip features into the store.
 * Call once in the app (e.g. Onboarding and AnonymousOnboarding) so that
 * features like 'mountableStorage' are enabled when their feature flag is on.
 * To add a new feature, only TOOLTIP_FEATURE_FLAGS needs to be updated.
 */
export function useSyncTooltipFeatureFlags() {
  const allFlags = useGetAllFeatureFlagStates();
  const isMountableStorageEnabled = useIsMountableStorageEnabled();

  useEffect(() => {
    Object.entries(TOOLTIP_FEATURE_FLAGS).forEach(([feature, flags]) => {
      const isEnabled = allFlags.some((flag) => {
        return flags.some((f) => f === flag.name && flag.enabled);
      });
      tooltipStore.setFeatureEnabled(feature, isEnabled);
    });
    // Custom keyboard shortcuts is GA — its discovery tooltip is always on.
    tooltipStore.setFeatureEnabled('customShortcuts', true);
  }, [allFlags, isMountableStorageEnabled]);
}
